export default __webpack_public_path__ + "static/media/transfiguration.70fd3c9b.jpg";